import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Container, Col } from 'react-bootstrap';
import Cookies from 'js-cookie';
import CockpitNotLoggedTopContainer from '../../containers/CockpitNotLoggedTopContainer';
import CockpitCategoriesContainer from '../../containers/CockpitCategoriesContainer';
import { DEMO_CATEGORY } from '../../constants/storageKeys';
import { SET_USER_SELECTED_CATEGORY } from '../../actions/user.action';
import Ads from '../../components/Ads/Ads';
import Image from '../../ui-components/Image/Image';
import { imageAbsolutePath } from '../../utils/utils';
import { useGetSelectedColorTheme } from '../../hooks/useGetSelectedColorTheme';
import styles from './CockpitNotLoggedPage.module.css';

const rulesImage = imageAbsolutePath('key-visual.jpeg');
const rulesImageDark = imageAbsolutePath('key-visualDark.png');

const CockpitNotLoggedPage: React.FC = () => {
  const dispatch = useDispatch();

  const { isDarkTheme } = useGetSelectedColorTheme();

  const rulesImageSrc = isDarkTheme ? rulesImageDark : rulesImage;

  useEffect(() => {
    const previousSelectedCategory = Cookies.getJSON(DEMO_CATEGORY);
    if (previousSelectedCategory) {
      dispatch(SET_USER_SELECTED_CATEGORY({ category: previousSelectedCategory }));
    }
  }, [dispatch]);

  return (
    <>
      <div className={styles.CockpitNotLoggedPage}>
        <Container>
          <Row>
            <Col>
              <div className={styles.rulesGroupContent}>
                <div className={styles.imgContainer}>
                  <Image src={rulesImageSrc} width="100%" />
                </div>
                <CockpitNotLoggedTopContainer />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Ads placement="mobile" />
      <CockpitCategoriesContainer />
      <Ads placement="desktop" />
    </>
  );
};

export default CockpitNotLoggedPage;
